<template>
  <div>
    <CCard class="bg-style2">
      <CCardHeader class="bg-gradient-danger text-white" style="border-top-left-radius: 1rem; border-top-right-radius: 1rem ">
        <span class="font-weight-bold h6"> <CIcon class="mr-2" v-if="icon" :name="icon"/> {{ caption }} </span>
      </CCardHeader>
      <CCardBody  class="pt-0 pb-0">
        <CRow>
          <CCol >
            <CCallout color="info">
              <small class="text-muted">เคสทั้งหมด</small><br>
              <strong class="h4">9,123</strong>
            </CCallout>
          </CCol>
          <CCol >
            <CCallout color="warning">
              <small class="text-muted ">กำลังดำเนินการ</small><br>
              <strong class="h4">22,643</strong>
            </CCallout>
          </CCol>

          <CCol >
            <CCallout color="danger">
              <small class="text-muted">เกิน SLA</small><br>
              <strong class="h4">9,123</strong>
            </CCallout>
          </CCol>
          <CCol >
            <CCallout color="success">
              <small class="text-muted ">ปิดเคสแล้ว</small><br>
              <strong class="h4">22,643</strong>
            </CCallout>
          </CCol>
        </CRow>


      </CCardBody>
    </CCard>
  </div>
</template>
<script>
import {mapGetters} from 'vuex'

export default {
  name: 'ECase',
  components: { },
  props: {
    icon: {
      type: String,
      default: 'cil-bell'
    },
    caption: {
      type: String,
      default: 'ศูนย์แจ้งเหตุฉุกเฉิน'
    },
    application: {
      type: String,
      default: '0'
    },
    hover: Boolean,
    striped: Boolean,
    bordered: Boolean,
    small: Boolean,
    fixed: Boolean,
    dark: Boolean,
    loading:{
      type: Boolean,
      default() {
        return false
      }
    },

  },
  data() {
    return {

    }
  },

  mounted() {

  },

  created() {
    this.onInit();
  },

  beforeDestroy() {

  },

  methods: {
    onInit() {

    },
  },

  computed: {
    ...mapGetters({
    })
  },

  watch: {
    lang: function (value) {

    },


  }
}

</script>
